import React, { useState } from "react";
import { cashInCashOutFormData } from "../App";
import CashInOutFilter from "../components/cash-in-cash-out/CashInOutFilter";
import Title from "../components/common/Title";
import moment from "moment";
import notify from "devextreme/ui/notify";
import { useAuth } from "../context/authContext";
import { requestERPLYData } from "../api/Server";
import CashInOutReportTable from "../components/cash-in-cash-out/CashInOutReportTable";
import { createRequestData, getResponseData } from "../utils/index";

const CashInCashOut = () => {
  const [reportStore, setReportStore] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const data = {
      requestName: "getCashIns",
      recordsOnPage: 100,
      sendContentType: 1,
      dateTimeFrom: moment(cashInCashOutFormData.startDate).format(
        "YYYY-MM-DD hh:mm:ss"
      ),
      dateTimeUntil: moment(cashInCashOutFormData.endDate).format(
        "YYYY-MM-DD hh:mm:ss"
      ),
    };

    if (cashInCashOutFormData.employee) {
      data.employeeID = parseInt(cashInCashOutFormData.employee, 10);
    }

    if (cashInCashOutFormData.reason) {
      data.reasonID = cashInCashOutFormData.reason;
    }

    const requestData = {
      requests: createRequestData(100, data),
      clientCode: user ? user.clientCode : "",
    };

    if (user && user.isIframe) {
      requestData.sessionKey = user.sessionKey;
    }

    try {
      const { data } = await requestERPLYData(requestData);
      if (data.status.responseStatus === "error") {
        notify("Error getting reports data, please try again", "error", 3000);
        setReportStore([]);
        setIsLoading(false);
      } else {
        setReportStore(getResponseData(data.requests, "CASH_IN_OUT"));
        setIsLoading(false);
      }
    } catch (error) {
      notify("Error getting reports data, please try again", "error", 3000);
      setReportStore([]);
      setIsLoading(false);
    }
  };

  return (
    <section className="mt-4">
      <Title pageTitle={"Cash In/Out Report"} />
      <CashInOutFilter
        formData={cashInCashOutFormData}
        handleSubmit={handleSubmit}
      />
      <CashInOutReportTable isLoading={isLoading} reportStore={reportStore} />
    </section>
  );
};

export default CashInCashOut;
